import { useCallback, useContext } from 'react';
import { LocaleConfigContext } from 'src/contexts/locale-config/locale-config';
import { eventTracker } from 'src/utils/EventTracker';

interface IHandleSearchSubmit {
    id: number;
    type: string;
    title: string;
}

export const useHandleSearchSubmit = ({ id, type, title }: IHandleSearchSubmit) => {
    const localeConfig = useContext(LocaleConfigContext);
    
    return useCallback(() => {
        if (!type) return;
        
        window.location.href = `https://www.${localeConfig.url}/${localeConfig.slugs.search}?filterParams[${type}][0]=${id}`;
        eventTracker.track({
            event: 'click',
            category: 'sticky-bar',
            action: 'search-button',
            label: `${type}-${title}`,
        });
    }, [id, type, localeConfig.slugs.search, localeConfig.url]);
};

